export const SUPPORTED_LOCALES = ['en-US', 'de-DE'] as const;
export const DEFAULT_LOCALE = 'de-DE';

export const resolveLocale = (
  browserLang: string = navigator.language
): string => {
  if ((SUPPORTED_LOCALES as readonly string[]).includes(browserLang)) {
    return browserLang;
  }

  const base = browserLang?.split('-')[0]?.toLowerCase();
  const match = SUPPORTED_LOCALES.find(l => l.startsWith(base + '-'));
  return match ?? DEFAULT_LOCALE;
};
